import { render } from "./BuekTemplateIframe.vue?vue&type=template&id=46202172&ts=true"
import script from "./BuekTemplateIframe.ts?vue&type=script&lang=ts&external"
export * from "./BuekTemplateIframe.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__